<template>

  <!--rev 040525 
  cobranza  
  -->
  <div>
    <PdfModal
        v-model="mostrarPdfRecibo"
        title="Vista de"
        :file-name="`Factura ${this.idRecibo}`"
        :fetch-document="obtenerPdfRecibo"
    />
     <PdfModal
        v-model="mostrarPdfFactura"
        title="Vista de"
        :file-name="`Factura ${this.idFactura}`"
        :file-type="this.tipoFactura"
        :fetch-document="obtenerPdfFactura"
      />
    <v-dialog v-model="localIsOpen" mobile-breakpoint="600" >
      <v-card>
        <v-card-title class="text-h6 gris--text">Recibos de membresía {{ this.localMembresia
        }} </v-card-title>
        <v-card-text>
          <v-data-table :items-per-page="-1" height="40vh" calculate-widths :headers="headers" :items="pagosModificados"
            item-key="Folio" class="elevation-1 table-responsive" :search="search" :footer-props="{
              'items-per-page-text': 'Filas por página',
            }" no-data-text="No existen citas en vigencia actual" fixed-header>
            <template v-slot:[`item.NumRecibo`]="{ item }">
              <td>
                <strong>{{ item.NumRecibo }}</strong> de <strong>{{ item.TotalRecibos }}</strong>
              </td>
            </template>
            <template v-slot:[`item.Retardo`]="{ item }">
              <td v-if="item.IsPagado === 0">
                <span v-if="item.Retardo > 1" class="text-rojo">{{ item.Retardo }}
                  días retardo</span>
                 <span v-if="item.Retardo === 0" class="text-rojo">
                  Hoy</span>
                 <span v-if="item.Retardo < 0" style="color: olivedrab;">A TIEMPO</span>
              </td>
              <td v-if="item.IsPagado === 1">
                <span>
                  <v-btn v-if="item.IsPagado === 1 && item.Factura !== null" icon
                    @click="verFactura(item.Factura, 'pdf')">
                    <v-icon size="20" color="red">mdi-file-pdf-box</v-icon>
                  </v-btn>
                  <v-btn v-if="item.IsPagado === 1 && item.Factura !== null" icon
                    @click="verFactura(item.Factura,'xml')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <text x="6" y="19" font-size="6" fill="currentColor">&lt;XML&gt;</text>
                    </svg>
                  </v-btn>
                  <v-btn text dense v-if="item.IsPagado === 1 && item.Factura === null" disabled
                    class="text--secondary">
                    SIN FACTURA
                  </v-btn>
                </span>
              </td>
            </template>
            <template v-slot:[`item.IsPagado`]="{ item }">
              <td class="text-center" v-if="item.IsPagado === 0">
                IMPAGO
              </td>
              <td v-else dark class="elemento-pagado text-center">
                <strong>PAGADO</strong>
                <div class="small-chip">
                  {{ item.FormaPago }}
                </div>
              </td>
            </template>
            <template v-slot:[`item.Total`]="{ item }">
              <td>
                <span class="estatus-activo">{{ $formatCurrency(item.Total) }}</span>
              </td>
            </template>
            <template v-slot:[`item.ops`]="{ item }">
              <v-menu offset-y left :close-on-content-click="true">
                <template v-slot:activator="{ on, attrs }">
                  <td><v-btn @click="selectRow(item)"
                      :class="{ 'selected-row': selectedRow && selectedRow === item.idpago }" red icon v-bind="attrs"
                      v-on="on">
                      <v-icon size="28">mdi-dots-vertical-circle-outline</v-icon>
                    </v-btn></td>
                </template>
                <v-list>
                  <!-- <v-list-item :disabled="!(item.IsPagado == '0')" @click="accionAplicaPago(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-star</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>VER PARA APLICAR</v-list-item-title>
                  </v-list-item> -->

                  <v-list-item @click="verRecibo(item.idpago)"> 
                    <v-list-item-icon>
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> VER RECIBO</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="enviarCorreo(item)">
                    <v-list-item-icon>
                      <v-icon>mdi-email-fast</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> ENVIAR RECIBO</v-list-item-title>
                  </v-list-item> 
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">CERRAR </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

     <send-email-recibo-modal 
      :isOpen.sync="showModalSendRecibo" 
      :item="selectedRow" 
      @close="closeModalSendPago" />
    <!-- <modal-pago :isOpen.sync="dialogPagoShow" :item="selectedRow" @save="aplicaPagoActiva"
      @close="dialogPagoShow = false"></modal-pago> -->
    </div>
</template>
<script>
//import ApiBase from '@/functions/axios/axiosNetBase'
import SendEmailReciboModal from '@/components/modals/modalSendEmailReciboComponent.vue'
//import ModalPago from '@/components/Pagos/modalAplicaPagoComponent.vue'
import PdfModal from "@/components/PdfModalComponent.vue";

export default {
  name: "ModalForm",
  components: {
    SendEmailReciboModal, PdfModal
    // ModalPago
  },
  computed: {
    dialogMaxWidth() {
      return this.$vuetify.breakpoint.mdAndUp ? '60%' : '95%';
    },
    pagosModificados() {
      return this.Recibos.map(pago => ({
        ...pago,
        grupo: `${pago.Contrato} - ${pago.Estatus} -  ${pago.Colectivo !== null ? '' + pago.Colectivo : ''}`
      }));
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
      required: true
    },
    Membresia: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      idRecibo: null,
      mostrarPdfFactura: false,
      mostrarPdfRecibo: false,
      idFactura: null,
      tipoFactura: 'pdf',
      dialogPagoShow: false, // modal aplica pago
      search: '',
      // selectedPago: null,
      selectedRow: null,
      showModalSendRecibo: false,
      FecHoy: new Date(),
      Recibos: [],
      localIsOpen: this.isOpen, // Variable local para manejar el estado del modal
      localMembresia: this.Membresia,
      headers: [
        { text: 'Folio', value: 'Folio', sortable: false },
        //{ text: 'Contrato', value: 'contrato', width: '10%', sortable: true },
        //{ text: "Contrato", value: "contrato", align: "d-none" }, // Columna oculta
        //{ text: 'Contratante', value: 'Contratante', width: '15%', sortable: false },
        //{ text: 'Titular', value: 'Titular', width: '15%', sortable: false },
        //{ text: 'Agente', value: 'agente', sortable: true },
        { text: 'Recibo', value: 'NumRecibo', sortable: false },
        { text: 'Retardo / factura', value: 'Retardo', sortable: false },
        { text: 'Estatus', value: 'IsPagado', sortable: false },
        { text: 'Fecha Pago', value: 'DatePagoFormat', sortable: false },
        { text: 'Aplicado', value: 'FecPagoFormat', sortable: false },
        { text: 'Monto', value: 'Total', sortable: false, align: 'end' },
        { text: 'Opciones', value: 'ops', sortable: false, align: 'center' },
      ],
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      loading: false
    };
  },
  watch: {
    isOpen(val) {
      this.localIsOpen = val;
    },
    localIsOpen(val) {
      this.tryFetchData();
      this.$emit('update:isOpen', val);
    },
    Membresia(val) {
      this.localMembresia = val;
      this.tryFetchData();
    }
  },
  methods: {
    verRecibo(recibo){
      this.idRecibo = recibo
      this.mostrarPdfRecibo = true
    },
    async obtenerPdfRecibo(){
     return await  this.$http.get(`file/${this.idRecibo}/RECIBO_PAGO/pdf`,
            {
               responseType: 'blob'
            })
    },
    async obtenerPdfFactura(){
    return await  this.$http.get(`file/VerFactura/${this.idFactura}/${this.tipoFactura}`,
      {
          responseType: 'blob'
      })
    },
    verFactura(idfactura, tipo){
      this.idFactura = idfactura
      this.tipoFactura = tipo
      this.mostrarPdfFactura = true
    },
    tryFetchData() {
      if (this.localIsOpen && this.localMembresia) {
        this.ObtienePagos();
      }
    },
    checkAndFetch() {
      if (this.localIsOpen && this.userId) {
        this.fetchData(this.userId);
      }
    },
    enviarCorreo(item) {
      this.selectedRow = item
      this.selectedRow.Email = item.EmailClient
      this.selectedRow.idpago = item.idpago
      
      this.showModalSendRecibo = true
    },
    // openModalPago(item) {

    //   this.selectedPago = { ...item }
    //   this.dialogPagoShow = true
    // },
    accionAplicaPago(){
      this.localIsOpen = false;

      const memId = this.localMembresia?.Id || null;

      // Verificar si ya estamos en la ruta "cobranza" con el mismo parámetro
      if (
        this.$route.name === 'cobranza' &&
        this.$route.params.mem === memId
      ) {
        return; // ya estamos aquí, no hacemos nada
      }

      // Navegar solo si es diferente
      if (memId) {
        this.$router.push({ name: 'cobranza', params: { mem: memId } });
      } else {
        this.$router.push({ name: 'cobranza' });
      }
    },
    closeModalSendPago(val) {
      this.showModalSendRecibo = val
    },
    selectRow(item) {

      this.selectedRow = item;
      this.selectedRow.Email = item.EmailClient
      this.selectedRow.idpago = item.idpago

    },
    customFilter(value, search, item) {
      return item.contrato.toLowerCase().includes(search.toLowerCase()) ||
        item.contratante.toLowerCase().includes(search.toLowerCase()) ||
        item.pago.toString().includes(search);
    },
    getRowClass(item) {
      //console.log(item)
      this.selectedRow = item;
      this.selectedRow.Email = item.EmailClient
      this.selectedRow.idpago = item.idpago
      return this.selectedRow && this.selectedRow === item.idpago ? 'selected-row' : '';
    },

    ObtienePagos() {
      this.loading = true;
      this.$http.get(`Cobranza/membresia?id=${this.localMembresia}`)
        .then(response => {
          if (response.status === 200) {
            this.Recibos = response.data
          }
        })
        .catch(() => {
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        alert("Form submitted!");
        this.$emit("form-submitted", this.formData); // Emit event with form data
        this.close();
      }
    },
    close() {
      this.Recibos = []
      this.localIsOpen = false; // Cierra el modal
    },
  },
};
</script>

<style scoped>
.v-card {
  margin-top: 20px;
  padding: 20px;
}
</style>